function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Flex, Text } from '@tapresearch/ui/components';
export var BreadcrumbText = function(_param) {
    var _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, rightElement = _param.rightElement, children = _param.children, rest = _object_without_properties(_param, [
        "active",
        "rightElement",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(Flex, {
        position: "relative",
        h: "100%",
        align: "center"
    }, /*#__PURE__*/ React.createElement(Text, _object_spread({
        transitionProperty: 'common',
        transitionDuration: 'normal',
        fontSize: {
            base: 'md',
            md: 'lg'
        },
        fontWeight: 'medium',
        position: 'relative',
        maxW: {
            base: '190px',
            md: '340px'
        },
        color: active ? 'gray.800' : 'gray.500',
        py: 1,
        px: 1,
        _hover: {
            color: active ? 'gray.800' : 'blue.800'
        }
    }, rest), children), rightElement);
};
